import * as React from 'react'

import { cn } from '@/lib/utils'

export type TextareaProps =
  React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
    /**
     * Transaction name for RUM monitoring.
     * Required for observability - tracks user interactions in Elastic APM.
     * Format: area.page.field_name (e.g., "admin.login.username")
     */
    transactionName: string
  }

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, transactionName, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          'text-primary ring-purple-50 transition ease-out',
          'focus-visible:border-transparent focus-visible:ring-2 focus-visible:ring-ring',
          'w-full rounded-xl border p-4 outline-none focus-visible:shadow-fieldshadow',
          'peer',
          className
        )}
        ref={ref}
        data-transaction-name={transactionName}
        {...props}
        rows={4}
        cols={15}
      />
    )
  }
)
Textarea.displayName = 'Textarea'

export { Textarea }
